import apisauce from 'apisauce'
import DataUtils from '../Utils/DataUtils'
import { NvApiConfig } from '../Configs'
import { encrypt } from '../Utils/Encrypt'
import AuthUtils from '../Utils/AuthUtils'

const config = __CONFIG__
const apiClients = []
let _token = null
let _shipperId = null
let _locale = null

const create = ({
  url,
  country = 'global',
  service,
  transform = true,
  timeout = 10000,
  protect = false,
  auth = false,
  responseType = 'json'
} = {}) => {
  const api = apisauce.create({
    baseURL: url || NvApiConfig.getBaseURL({ country, service }),
    headers: {
      'Content-Type': 'application/json'
    },
    timeout,
    responseType
  })
  api.service = service
  apiClients.push(api)
  api.addRequestTransform(request => {
    if (transform) {
      request.data = DataUtils.toSnakeCase(request.data)
    }
    if (protect && config.API_PROTECT_SECRET) {
      // Assuming this is used in browser
      const adjustment = window.PROTECT_TIME_ADJUSTMENT || 0
      const timestamp = (Date.now() / 1000 + adjustment / 1000).toFixed(0) // in seconds
      request.headers[NvApiConfig.PROTECTION_KEY_HEADER] = encrypt(timestamp, config.API_PROTECT_SECRET)
    }
  })
  api.addResponseTransform(response => {
    if (transform) {
      response.data = DataUtils.toCamelCase(response.data)
    }

    if (auth && response.status === 401) {
      AuthUtils.goToLogin()
    }
  })

  if (_token) {
    api.setHeader(NvApiConfig.AUTH_HEADER, NvApiConfig.getAuth(_token))
  }

  if (_shipperId) {
    api.setHeader(NvApiConfig.SHIPPER_HEADER, _shipperId)
  }

  if (_locale) {
    api.setHeader(NvApiConfig.LANGUAGE_HEADER, _locale)
  }

  if (config.ENVIRONMENT === 'local' && config.USE_LOCAL_API !== 'false') {
    api.setHeader(NvApiConfig.SYSTEM_ID_HEADER, country)

    // token to identify correlating requests and responses
    // some service require this to be passed in (eg: route service)
    api.setHeader(NvApiConfig.REQUEST_ID_HEADER, 'LOCAL_REQUEST_ID_PLACEHOLDER')
  }

  return {
    api
  }
}

const setAuthToken = token => {
  _token = token
  return apiClients.forEach(apiClient => {
    apiClient.setHeader(NvApiConfig.AUTH_HEADER, NvApiConfig.getAuth(token))
  })
}

const removeAuthToken = () => {
  _token = null
  return apiClients.forEach(apiClient => {
    apiClient.deleteHeader(NvApiConfig.AUTH_HEADER)
  })
}

const setShipper = shipperId => {
  _shipperId = shipperId
  return apiClients.forEach(apiClient => {
    apiClient.setHeader(NvApiConfig.SHIPPER_HEADER, shipperId)
  })
}

const removeShipper = () => {
  _shipperId = null
  return apiClients.forEach(apiClient => {
    apiClient.deleteHeader(NvApiConfig.SHIPPER_HEADER)
  })
}

const clean = () => {
  removeAuthToken()
  removeShipper()
}

const setLanguage = locale => {
  _locale = locale
  return apiClients.forEach(apiClient => {
    apiClient.setHeader(NvApiConfig.LANGUAGE_HEADER, locale)
  })
}

export default {
  apiClients,
  create,
  setAuthToken,
  removeAuthToken,
  setShipper,
  removeShipper,
  clean,
  setLanguage,
  SHIPPER_HEADER: NvApiConfig.SHIPPER_HEADER
}
